import { render, staticRenderFns } from "./hobo_paid.vue?vue&type=template&id=070ddd84&scoped=true"
import script from "./hobo_paid.vue?vue&type=script&lang=js"
export * from "./hobo_paid.vue?vue&type=script&lang=js"
import style0 from "./hobo_paid.vue?vue&type=style&index=0&id=070ddd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ddd84",
  null
  
)

export default component.exports